// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_in-0";
export var fileCarousel = "_in-2";
export var removeFileButton = "_in-1";